import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { debounce } from 'lodash';
import { compose } from 'redux';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { setAPIParams, REDUCER_NAME } from '../../reducer';

const KEY_ENTER = 13;

const initialState = {
  value: '',
};

class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.updateInputValue = debounce(this.updateInputValue, 1500);
    this.state = {
      value: this.props.defaultSearch || '',
    };
  }

  componentDidMount() {
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillReceiveProps = nextProps => {
    const { currentTab } = this.props;
    if (currentTab !== nextProps.currentTab) {
      if (nextProps.apiParams.KeyWord === null) {
        this.setState(initialState);
        return;
      }
      this.setState({
        value: nextProps.apiParams.KeyWord,
      });
    }
  };

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, componentId } = this.props;
    const isSameComponent =
      data.componentId && data.componentId === componentId;
    if (
      syncType === TYPE_DISABLE ||
      syncType !== data.syncType ||
      isSameComponent
    ) {
      return;
    }
    const text = data.search.displayCode;
    this.setState({
      value: text,
    });
    this.handleSearch(text);
  };

  updateInputValue = KeyWord => {
    const query = KeyWord || null;
    this.handleSearch(query);
  };

  handleOnChange = e => {
    this.updateInputValue(e.target.value);
    this.setState({ value: e.target.value });
  };

  onKeyDown = e => {
    if (e.keyCode === KEY_ENTER) {
      this.updateInputValue.cancel();
      const KeyWord = e.target.value;
      const query = KeyWord || null;
      this.handleSearch(query);
    }
  };

  handleSearch = query => {
    const { setAPIParams, currentTab, currentChildTab, apiParams } = this.props;
    if (apiParams.KeyWord === null || apiParams.KeyWord !== query) {
      // if change keyword reset Page to 1
      return setAPIParams(
        { parentTab: currentTab, childTab: currentChildTab },
        { KeyWord: query, Page: 1 },
      );
    }

    setAPIParams(
      { parentTab: currentTab, childTab: currentChildTab },
      { KeyWord: query },
    );
  };

  render() {
    const { value } = this.state;
    return (
      <div className="na-search-box-wrapper">
        <input
          type="search"
          placeholder={I18n.t('common.search')}
          value={value}
          onChange={this.handleOnChange}
          onKeyDown={this.onKeyDown}
        />
        <button type="button" style={{ cursor: 'pointer' }}>
          <i className="icon-search" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId, componentName }) => {
  return {
    i18n: state.i18n,
    currentTab: state[REDUCER_NAME].currentTab,
    currentChildTab: state[REDUCER_NAME].currentChildTab,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setAPIParams: (tabNumber, apiParams) =>
      dispatch(setAPIParams(tabNumber, apiParams)),
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(mapStateToProps, mapDispatchToProps),
)(SearchBox);
